import LineSearchIcon from 'LuxKit/Icons/line/LineSearchIcon'
import useCurrentGlobalSearchVerticalPage from 'hooks/GlobalSearch/useCurrentGlobalSearchVerticalPage'
import useGlobalSearchURLHashVertical from 'hooks/GlobalSearch/useGlobalSearchURLHashVertical'
import useGlobalSearchVerticalTabs from 'hooks/GlobalSearch/useGlobalSearchVerticalTabs'
import { preloadGlobalSearchV2Content } from 'components/SearchV2/GlobalSearchV2'
import { memo, useCallback } from 'react'
import styled from 'styled-components'
import NavBarButton from '../NavBarButton/NavBarButton'
import { mediaQueryUp } from 'components/utils/breakpoint'
import useNavBarShowsMobileSearchIcon from 'hooks/Navigation/useNavBarShowsMobileSearchIcon'

const IconSearchInput = styled(NavBarButton)`
  border-radius: ${props => props.theme.borderRadius.round};

  ${mediaQueryUp.tablet} {
    display: none;
  }
`

interface Props {
  className?: string
}

function NavBarSearchButton(props: Props) {
  const { className } = props
  const globalSearchVerticalTabs = useGlobalSearchVerticalTabs()
  const currentSearchVerticalPage = useCurrentGlobalSearchVerticalPage()
  const { toggleSearchVertical } = useGlobalSearchURLHashVertical()
  const showsMobileSearchIcon = useNavBarShowsMobileSearchIcon()

  const onSearchClick = useCallback(() => {
    const verticalTab = currentSearchVerticalPage ?? globalSearchVerticalTabs.keys().next().value
    toggleSearchVertical(verticalTab)
  }, [currentSearchVerticalPage, globalSearchVerticalTabs, toggleSearchVertical])

  const onSearchIntent = useCallback(() => {
    preloadGlobalSearchV2Content()
  }, [])

  if (!showsMobileSearchIcon) {
    return null
  }

  return <IconSearchInput
    className={className}
    icon={<LineSearchIcon />}
    onClick={onSearchClick}
    onMouseEnter={onSearchIntent}
    onFocus={onSearchIntent}
  />
}

export default memo(NavBarSearchButton)
